export default "__VITE_ASSET__BX1j0vqE__"